import script from "./WCPaymentOptionBadgesModernCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCPaymentOptionBadgesModernCard.vue?vue&type=script&setup=true&lang=ts"

import "./WCPaymentOptionBadgesModernCard.vue?vue&type=style&index=0&id=37769b78&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37769b78"]])

export default __exports__